<div class="modal-header">
  <h4 class="modal-title">Label</h4>
<!--  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">-->
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close('Cross click')">

  </button>
</div>
<div class="modal-body">
  <form [formGroup]="labelForm" (ngSubmit)="onFormSubmit()" id="ngForm">
    <div class="row">
      <div class="col-md-12">
        <label class="form-label">{{'module'|translate}} <span class="text-danger">*</span></label>
        <ng-select
                [loading]="true"
                [loadingText]="loading"
                [items]="modules"
                bindLabel="name"
                bindValue="id"
                placeholder="{{'choose a module'|translate}}"
                formControlName="module"
                [ngClass]="{'is-invalid': fc['module'].invalid && isSubmitted}"
                [(ngModel)]="moduleSelected"
        >

          <ng-template ng-loadingspinner-tmp></ng-template>

        </ng-select>
        <div class="invalid-feedback" *ngIf="fc['module'].errors?.['required']">{{'this field is required'|translate}}</div>
        <div class="invalid-feedback" *ngIf="fc['module'].errors?.['serverError']">
          {{ fc['module'].errors?.['serverError'] }}
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-8">
        <label class="form-label">{{'name'|translate}} <span class="text-danger">*</span></label>
        <input class="form-control form-control-sm" type="text" placeholder="Ex. Permission" formControlName="name" [ngClass]="{'is-invalid': fc['name'].invalid && isSubmitted}">
        <small class="invalid-feedback fst-italic" *ngIf="fc['name'].errors?.['required']">{{'this field is required'|translate}}</small>
        <div class="invalid-feedback" *ngIf="fc['name'].errors?.['serverError']">
          {{ fc['name'].errors?.['serverError'] }}
        </div>
      </div>

      <div class="col-md-4">
        <label class="form-label">{{'position'|translate}} </label>
        <input class="form-control form-control-sm" type="number" placeholder="Ex. 10" formControlName="position" [ngClass]="{'is-invalid': fc['position'].invalid && isSubmitted}">
        <div class="invalid-feedback" *ngIf="fc['position'].errors?.['serverError']">
          {{ fc['position'].errors?.['serverError'] }}
        </div>
      </div>
    </div>

  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>


  <button form="ngForm" (submit)="onFormSubmit()" type="submit" class="btn btn-sm btn-outline-primary" [disabled]=saving>
    <ng-container *ngIf="!saving; else isSaving">{{data ? update : create}}</ng-container>
    <ng-template #isSaving>
      {{ "Submitting" | translate}} ...
    </ng-template>
  </button>

</div>














